import React from "react";
import Navbar from "@/components/Navbar";
import BookMeeting from "@/components/BookMeeting";
import Footer from "@/components/Footer";

export default function BookPage() {
  return (
    <main data-testid="book-page" className="bg-sand">
      <Navbar />
      <BookMeeting />
      <Footer />
    </main>
  );
}
